{
  "brand": {
    "name": "Быстренко",
    "suffix": ".ру",
    "href": "/",
    "icon": "ri-flashlight-line",
    "url": "https://bystrenko.ru",
    "legal": "ИП Быстренко А.В. ИНН 253711433438"
  },
  "contacts": {
    "phone": "+7 (977) 421-79-97",
    "phoneHref": "tel:+79774217997",
    "email": "amo@vnedrim-crm.ru",
    "emailHref": "mailto:amo@vnedrim-crm.ru"
  },
  "socials": [
    {
      "key": "telegram-support",
      "icon": "ri-telegram-line",
      "href": "https://t.me/zapusti_amocrm",
      "label": "Telegram — запуск amoCRM",
      "gradient": "from-yellow-400 to-red-400"
    },
    {
      "key": "telegram-impl",
      "icon": "ri-telegram-line",
      "href": "https://t.me/vnedrenie_amocrm",
      "label": "Telegram — внедрение",
      "gradient": "from-green-400 to-cyan-400"
    },
    {
      "key": "vk",
      "icon": "ri-vk-line",
      "href": "https://vk.com/amocrm_biz",
      "label": "ВКонтакте",
      "gradient": "from-violet-400 to-pink-400"
    },
    {
      "key": "max",
      "icon": "ri-chat-3-line",
      "href": "https://max.ru/u/f9LHodD0cOIlD4oazTGfRHvraoVoU6treAOCnC419YuJlJlqZiK6uydX1KU",
      "label": "MAX",
      "gradient": "from-cyan-400 to-blue-400"
    },
    {
      "key": "rutube",
      "icon": "ri-video-line",
      "href": "https://rutube.ru/channel/26534827/videos/",
      "label": "RuTube",
      "gradient": "from-pink-400 to-yellow-400"
    }
  ],
  "nav": {
    "links": [
      {
        "label": "Услуги",
        "href": "#services"
      },
      {
        "label": "Решения",
        "href": "#solutions"
      },
      {
        "label": "Интеграции",
        "href": "/integrations"
      },
      {
        "label": "Процесс",
        "href": "#process"
      },
      {
        "label": "Кейсы",
        "href": "#cases"
      },
      {
        "label": "Тарифы",
        "href": "#pricing"
      },
      {
        "label": "FAQ",
        "href": "#faq"
      },
      {
        "label": "Lean",
        "href": "/lean"
      },
      {
        "label": "БроньСРМ",
        "href": "/booker"
      },
      {
        "label": "Аналитика",
        "href": "/analytics"
      }
    ],
    "cta": {
      "label": "Получить консультацию",
      "href": "#contact"
    }
  },
  "footer": {
    "description": "Внедрение amoCRM и автоматизация бизнес-процессов под ключ. 350+ успешных проектов по всей России.",
    "columns": [
      {
        "title": "Услуги",
        "links": [
          {
            "text": "Внедрение amoCRM",
            "href": "#"
          },
          {
            "text": "Автоматизация",
            "href": "#"
          },
          {
            "text": "Интеграции",
            "href": "/integrations"
          },
          {
            "text": "Аналитика и отчётность",
            "href": "/analytics"
          },
          {
            "text": "Обучение",
            "href": "#"
          },
          {
            "text": "Поддержка",
            "href": "#"
          }
        ]
      },
      {
        "title": "Компания",
        "links": [
          {
            "text": "О нас",
            "href": "#"
          },
          {
            "text": "Кейсы",
            "href": "#"
          },
          {
            "text": "Решения",
            "href": "/solutions"
          },
          {
            "text": "Блог",
            "href": "#"
          },
          {
            "text": "Партнёрам",
            "href": "#"
          },
          {
            "text": "Карьера",
            "href": "#"
          }
        ]
      },
      {
        "title": "Контакты",
        "links": [
          {
            "text": "amo@vnedrim-crm.ru",
            "href": "mailto:amo@vnedrim-crm.ru"
          },
          {
            "text": "+7 (977) 421-79-97",
            "href": "tel:+79774217997"
          },
          {
            "text": "Telegram",
            "href": "https://t.me/zapusti_amocrm"
          },
          {
            "text": "RuTube",
            "href": "https://rutube.ru/channel/26534827/videos/"
          }
        ]
      }
    ],
    "copyright": "© 2026 Быстренко.ру. Все права защищены. Сертифицированный партнёр amoCRM.",
    "legalLinks": [
      {
        "text": "Политика обработки персональных данных",
        "href": "/policy_pd.docx"
      },
      {
        "text": "Условия использования",
        "href": "#"
      }
    ]
  },
  "webhookUrl": "https://go3.vnedrim-crm.ru/webhook/3057afc2-da28-4ff4-bde9-24b6ec758a61",
  "policyUrl": "/policy_pd.docx",
  "leadForm": {
    "name": "Имя",
    "namePlaceholder": "Иван Иванов",
    "phone": "Телефон",
    "phonePlaceholder": "+7 (___) ___-__-__",
    "comment": "Комментарий",
    "commentPlaceholder": "Какая система, сколько пользователей, что уже внедрено",
    "consent": "Согласен на обработку персональных данных согласно **политике конфиденциальности**",
    "submit": "Отправить заявку",
    "submitting": "Отправляем...",
    "successTitle": "Спасибо!",
    "successTextTemplate": "Мы свяжемся с вами в течение 15 минут и предложим схему подключения{{suffix}}.",
    "successAgain": "Отправить ещё одну заявку",
    "errorConsent": "Необходимо согласие с политикой обработки персональных данных",
    "errorGeneric": "Не удалось отправить заявку. Попробуйте ещё раз.",
    "successToast": "Спасибо! Мы свяжемся с вами в течение 15 минут."
  },
  "contactsList": [
    {
      "icon": "ri-mail-line",
      "text": "amo@vnedrim-crm.ru",
      "href": "mailto:amo@vnedrim-crm.ru"
    },
    {
      "icon": "ri-phone-line",
      "text": "+7 (977) 421-79-97",
      "href": "tel:+79774217997"
    }
  ],
  "seo": {
    "author": "Быстренко.ру",
    "siteName": "Быстренко.ру",
    "defaultOgImage": "/uploads/015d4336-c674-4961-be0b-98079834ca0a-mvs28fq0.png",
    "notFound": {
      "title": "Страница не найдена — Быстренко.ру",
      "description": "Запрошенная страница не найдена. Перейдите на главную Быстренко.ру — внедрение amoCRM и автоматизация бизнес-процессов под ключ.",
      "keywords": "404, страница не найдена, Быстренко.ру, amoCRM"
    },
    "solutionDetail": {
      "title": "Готовые решения для amoCRM — Быстренко.ру",
      "description": "Проверенные инструменты для amoCRM: генерация документов, умный подбор кандидатов, объекты недвижимости, расчёт зарплат, квиз-боты. Подключение за 1 день.",
      "keywords": "решения amoCRM, виджеты amoCRM, инструменты amoCRM, автоматизация CRM"
    }
  },
  "a11y": {
    "themeLight": "Включить светлую тему",
    "themeDark": "Включить тёмную тему",
    "menuClose": "Закрыть меню",
    "menuOpen": "Открыть меню"
  },
  "breadcrumbs": {
    "home": "Главная",
    "integrations": "Интеграции"
  }
}
